import { nonDeletablePredfinedComponentTypes } from 'components/SalaryStructure/constants';
import { CustomSalaryComponent, CustomSalaryComponentsAction } from './types';

export const customSalaryComponentsReducer = (
  state: CustomSalaryComponent[],
  action: CustomSalaryComponentsAction,
): CustomSalaryComponent[] => {
  switch (action.type) {
    case 'COMPONENTS_SYNC_FROM_MODAL': {
      const { components, libraryComponentIds } = action.payload;
      const libraryIdSet = new Set(libraryComponentIds);
      const selectedComponentIds = new Set(components.map((c) => c.componentId));
      const isNonRemovable = (c: CustomSalaryComponent) =>
        nonDeletablePredfinedComponentTypes.includes(c.componentType || 'COMPONENT_TYPE_NA');
      const kept = state.filter(
        (c) =>
          isNonRemovable(c) ||
          !libraryIdSet.has(c.componentId) ||
          selectedComponentIds.has(c.componentId),
      );
      const keptIds = new Set(kept.map((c) => c.componentId));
      const toAdd = components.filter((c) => c.componentId && !keptIds.has(c.componentId));
      return [...kept, ...toAdd];
    }

    case 'COMPONENT_DELETED':
      return state.filter((component) => component.id !== action.payload.id);

    case 'COMPONENT_AMOUNT_CHANGED':
      return state.map((component) =>
        component.id === action.payload.id
          ? { ...component, amount: action.payload.amount }
          : component,
      );

    case 'INITIALIZE_COMPONENTS':
      return action.payload.initialComponents;

    default:
      return state;
  }
};